module.exports = __webpack_public_path__ + "img/75741.e2392082.svg";